define("shared/helpers/unwrap-proxy", ["exports", "@ember/component/helper", "later/utils/object-promise-proxy"], function (_exports, _helper, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.unwrapProxy = unwrapProxy;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f
  function unwrapProxy(_ref) {
    let [o] = _ref;
    return (0, _objectPromiseProxy.default)(o);
  }
  var _default = _exports.default = (0, _helper.helper)(unwrapProxy);
});